import styled from '@emotion/styled'

export const LargeText = styled.div`
  color: #505050;
  font-size: 1.5rem;
  white-space: nowrap;
`
